export const addNoScrollBody = () => {
  // Scrollbar fixer: stops the page from jumping due to scroll bar change
  // (Needed for Mac OS only on certain settings, and Windows always)
  const scrollBar = window.innerWidth - document.documentElement.clientWidth;
  if (scrollBar > 0) {
      const style = document.createElement('style');
      style.className = 'scrollbar-fixer-style';
      style.innerText = `.scrollbar-fixer{padding-right: ${scrollBar}px;}`;
      document.head.appendChild(style);
      document.body.classList.add('scrollbar-fixer');
  }
  document.body.classList.add('no-scroll');
};

export const removeNoScrollBody = () => {
  // remove scrollbar fixer
  const style = document.querySelector('.scrollbar-fixer-style');
  if (style) {
    style.parentNode.removeChild(style);
  }
  document.body.classList.remove('no-scroll');
  document.body.classList.remove('scrollbar-fixer');
};
